import { BoelsGenericState, Alternate } from '@boels/models';
import * as fromAction from '../actions/boels-alternates.actions';

export interface BoelsAlternatesState extends BoelsGenericState {
  alternates: BoelsAlternateList;
}

export interface BoelsAlternateList {
  [categoryId: string]: Alternate[];
}

export const initialState: BoelsAlternatesState = {
  alternates: {},
  error: false,
  loading: false,
  success: false,
};

export function reducer(
  state = initialState,
  action: fromAction.BoelsAlternatesAction,
): BoelsAlternatesState {
  switch (action.type) {
    case fromAction.LOAD_ALTERNATES: {
      return {
        ...state,
        loading: true,
        success: false,
        error: false,
      };
    }
    case fromAction.LOAD_ALTERNATES_FAIL: {
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      };
    }
    case fromAction.LOAD_ALTERNATES_SUCCESS: {
      const alternates = { ...state.alternates };
      alternates[action.payload.categoryCode] = action.payload.alternates;
      return {
        ...state,
        alternates,
        loading: false,
        success: true,
        error: false,
      };
    }
    default: {
      return state;
    }
  }
}
